import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Currency } from '../../../components/common/Form/config';
import { LoadState } from '../../../pages/store/types';
import rateSvc from '../../../services/rate/rateSvc';
import { ExchangeResponse, IExchange } from '../../../services/rate/types';
import { camelCaseMapData } from '../../../utils/formater';

type RateState = LoadState<IExchange>;

export const initialState: RateState = {
  error: '',
  loading: false,
  data: null,
};

// TODO: Remove it
const fetchExchange = createAsyncThunk(
  'fetchExchange',
  async ({
    currency,
    desCurrency,
    enterpriseId,
  }: {
    currency: Currency;
    desCurrency?: Currency;
    enterpriseId: string;
  }) => rateSvc.getExchange({ currency, desCurrency, enterpriseId })
);

export const exchangeSlice = createSlice({
  name: 'balance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchExchange.pending, (state) => {
      state.loading = true;
      state.error = '';
      state.data = null;
    });
    builder.addCase(fetchExchange.fulfilled, (state, { payload: exchange }) => {
      state.loading = false;
      state.data = camelCaseMapData<ExchangeResponse, IExchange>(exchange);
      state.error = '';
    });

    builder.addCase(fetchExchange.rejected, (state) => {
      state.loading = false;
      state.data = null;
      state.error = 'ERROR';
    });
  },
});

export { fetchExchange };
export default exchangeSlice.reducer;
